module.exports = function() {
  return new Worker(__webpack_public_path__ + "ca4df1c09a1ac4a80684.worker.js");
};